import { render, staticRenderFns } from "./OrdenTrabajo.vue?vue&type=template&id=d187537e&scoped=true"
import script from "./OrdenTrabajo.vue?vue&type=script&lang=js"
export * from "./OrdenTrabajo.vue?vue&type=script&lang=js"
import style0 from "./OrdenTrabajo.vue?vue&type=style&index=0&id=d187537e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d187537e",
  null
  
)

export default component.exports